import React from 'react';

import styles from './styled-mobile-table.module.scss';
export const Header = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['header']} ${className}` : styles['header']} {...props} />
);

export const Title = ({ className, ...props }: React.ComponentPropsWithoutRef<'h1'>) => (
  <h1 className={className ? `${styles['title']} ${className}` : styles['title']} {...props} />
);

export const TableContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['table-container']} ${className}` : styles['table-container']}
    {...props}
  />
);

export const RowTitle = ({ className, ...props }: React.ComponentPropsWithoutRef<'h2'>) => (
  <h2
    className={className ? `${styles['row-title']} ${className}` : styles['row-title']}
    {...props}
  />
);

export const RowSubtitle = ({ className, ...props }: React.ComponentPropsWithoutRef<'h6'>) => (
  <h6
    className={className ? `${styles['row-subtitle']} ${className}` : styles['row-subtitle']}
    {...props}
  />
);

export const RowHeader = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['row-header']} ${className}` : styles['row-header']}
    {...props}
  />
);

export const VerticalCell = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['vertical-cell']} ${className}` : styles['vertical-cell']}
    {...props}
  />
);

export const HorizontalCell = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['horizontal-cell']} ${className}` : styles['horizontal-cell']}
    {...props}
  />
);

export const CellLabel = ({ className, ...props }: React.ComponentPropsWithoutRef<'span'>) => (
  <span
    className={className ? `${styles['cell-label']} ${className}` : styles['cell-label']}
    {...props}
  />
);

export const CellContent = ({ className, ...props }: React.ComponentPropsWithoutRef<'span'>) => (
  <span
    className={className ? `${styles['cell-content']} ${className}` : styles['cell-content']}
    {...props}
  />
);

export const RowContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['row-container']} ${className}` : styles['row-container']}
    {...props}
  />
);
